import { render, staticRenderFns } from "./ItemAvailability.vue?vue&type=template&id=3f09aa68&"
import script from "./ItemAvailability.vue?vue&type=script&lang=js&"
export * from "./ItemAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentySyncs/9735/119/casaPadrino/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f09aa68')) {
      api.createRecord('3f09aa68', component.options)
    } else {
      api.reload('3f09aa68', component.options)
    }
    module.hot.accept("./ItemAvailability.vue?vue&type=template&id=3f09aa68&", function () {
      api.rerender('3f09aa68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/ItemAvailability.vue"
export default component.exports